import axios from 'axios'
import { getCache, setCache } from '../cache'
import { serverUrl } from '../../common/helper/serverUrl'

const CACHE_KEY = 'project-choices'
let choicesPromise = null

export function getProjectChoices() {
  // If a previous request is still in progress, return its Promise.
  if (choicesPromise) {
    return choicesPromise
  }

  // Try to return cached data.
  let choices = getCache(CACHE_KEY)
  if (choices !== null) {
    return Promise.resolve(choices)
  }

  // If not in cache or expired, fetch new data.
  choicesPromise = axios.get(serverUrl('/project/choice-list'))
    .then(response => {
      setCache(CACHE_KEY, response.data.projects, 10000)
      // Reset the promise after the request completes
      choicesPromise = null
      return response.data.projects
    })
    .catch(error => {
      // Reset the promise if there's an error
      choicesPromise = null
      throw error
    })

  return choicesPromise
}
